'use client'

import { useEffect } from 'react'

import { captureFromUrl, URL_FORWARDABLE } from '@/app/utils/attribution'

// Mirror Rails' [0..244] truncation on the cookie value side.
const MAX_FIELD_LENGTH = 244

// Mirrors Webflow's old UTM-forwarding behavior: persist tracking params
// from the landing URL into sessionStorage so outbound links to legacy
// Rails paths can re-attach them.
//
// Also fires Rails' /attr_set.gif tracking pixel on every first landing.
// /users/sign_up is now SPA-served (CDN, not Rails), so Rails' gtm_cookie
// never fires on that page load and the signed cookies that TrackSignUp
// later reads stay empty. The pixel hit goes to Rails directly, which runs
// gtm_cookie as a before_action and writes the signed utm, gclid, entry
// (first_page) and referer cookies. Webflow used to load this same pixel
// on every page.
export const AttributionCapture = () => {
  useEffect(() => {
    captureFromUrl()

    const search = new URLSearchParams(window.location.search)
    const tracking = new URLSearchParams()
    for (const key of URL_FORWARDABLE) {
      const value = search.get(key)
      if (value) tracking.set(key, value)
    }
    // Pass these explicitly — Rails would otherwise derive them from
    // request.original_url / request.referer, which for a pixel hit point
    // at /attr_set.gif itself. The companion gtm_cookie patch reads these
    // as the preferred source.
    tracking.set('first_page', window.location.href.slice(0, MAX_FIELD_LENGTH))
    if (document.referrer) {
      tracking.set('referral', document.referrer.slice(0, MAX_FIELD_LENGTH))
    }

    new Image().src = `/attr_set.gif?${tracking.toString()}`
  }, [])

  return null
}
